export default "__VITE_ASSET__107b76f2__"